import React from 'react';
import PropTypes from 'prop-types';
import { getFinancialDate, parseCivilDate } from '../../domain/finance';
import './styles.css';

const SHORT_MONTHS = [
  'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
  'jul', 'ago', 'set', 'out', 'nov', 'dez',
];

const LONG_MONTHS = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

export const formatTransactionDateBadge = (record) => {
  const date = getFinancialDate(record);
  const parsed = parseCivilDate(date);

  if (!parsed) {
    return { date: null, day: '--', month: 'data', label: 'Data inválida' };
  }

  return {
    date,
    day: String(parsed.day).padStart(2, '0'),
    month: SHORT_MONTHS[parsed.month - 1],
    label: `${parsed.day} de ${LONG_MONTHS[parsed.month - 1]} de ${parsed.year}`,
  };
};

const TransactionDateBadge = ({ record }) => {
  const formatted = formatTransactionDateBadge(record);

  return (
    <time
      className="transaction-date-badge"
      dateTime={formatted.date || undefined}
      aria-label={formatted.label}
    >
      <strong>{formatted.day}</strong>
      <span>{formatted.month}</span>
    </time>
  );
};

TransactionDateBadge.propTypes = {
  record: PropTypes.object.isRequired,
};

export default TransactionDateBadge;